<script setup lang='ts'>
import { useCarSeries } from './hooks'
import type { SeriesItem, SeriesResponse } from '@/server/types'
import { LOAD_STATE } from '@/shared/types'

const props = withDefaults(defineProps<{
  brandId?: number
  seriesId?: number
}>(), {})
const emits = defineEmits({
  select: (_data: SeriesItem & Omit<SeriesResponse, 'seriesLs'>) => true,
})

const {
  loadState,
  seriesList,
  getSeriesList,
} = useCarSeries()

function select(series: SeriesItem, key: SeriesResponse) {
  emits('select', {
    ...series,
    carVendorName: key.carVendorName,
    carVendorId: key.carVendorId,
    brandVendorId: key.brandVendorId,
  })
}

function getData() {
  if (props.brandId)
    getSeriesList(props.brandId)
}

watchEffect(getData)
</script>

<template>
  <div class="car-container">
    <UtilLoadState :state="loadState" :reload-handler="getData">
      <div v-if="loadState === LOAD_STATE.END && seriesList && seriesList.length" class="car-list">
        <div v-for="key in seriesList" :key="key.carVendorName">
          <div class="car-key">
            {{ key.carVendorName }}
          </div>
          <div v-if="key.seriesLs && key.seriesLs?.length" class="flex flex-wrap p-3">
            <div
              v-for="series in key.seriesLs" :key="series.id"
              class="car-item"
              :class="{ active: series.id === seriesId }"
              @click="select(series, key)"
            >
              {{ series.carSeriesName }}
            </div>
          </div>
        </div>
      </div>
      <div v-else class="car-empty">
        <BasicEmpty text="暂无相关车系数据" />
      </div>
    </UtilLoadState>
  </div>
</template>

<style lang='scss' scoped>
@import './index.scss';
</style>
